<script setup>
import { defineProps } from 'vue';

defineProps({
  steps: {
    type: Array,
    required: true
  },
  currentStep: {
    type: Number,
    required: true
  },
});
</script>

<template>
  <div class="flex items-center">
    <template v-for="(step, index) in steps" :key="index">
      <div class="flex items-center" :class="{ 'hidden sm:flex': index + 1 !== currentStep }">
        <div
          class="stepper-item flex items-center justify-center w-6 h-6 sm:w-9 sm:h-9 2xl:w-12 2xl:h-12 rounded-full text-white font-medium text-lg 2xl:text-xl transition-all duration-500"
          :class="[
            index + 1 < currentStep
              ? 'bg-gradient-to-br from-emerald-500 to-emerald-700 scale-110'
              : index + 1 === currentStep
                ? 'bg-gradient-to-br from-amber-400 to-amber-600 scale-110 pulse-effect'
                : 'bg-gradient-to-br from-slate-700/70 to-slate-900'
          ]">
          <span v-if="index + 1 < currentStep" class="check-icon"><svg
              class="w-5 h-5 sm:w-6 sm:h-6 text-gray-800 dark:text-white" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 11.917 9.724 16.5 19 7.5" />
            </svg>
          </span>
          <span class="text-sm md:text-base 2xl:text-lg" v-else>{{ index + 1 }}</span>
        </div>
        <div class="ml-3 font-medium text-sm md:text-base 2xl:text-lg transition-all duration-300 "
          :class="{ 'text-amber-500 font-bold': index + 1 === currentStep, 'text-emerald-500': index + 1 < currentStep }">
          {{ step }}</div>
      </div>
      <div v-if="index < steps.length - 1"
        class="mx-2.5 md:mx-4 border-t-2 border-dotted w-16 transition-all duration-500 hidden sm:block" :class="[
          index + 1 < currentStep
            ? 'border-emerald-600 border-solid animate-line-advance'
            : 'border-gray-600'
        ]"></div>
    </template>
  </div>
</template>

<style scoped>
.stepper-item {
  position: relative;
  overflow: hidden;
}

.check-icon {
  animation: zoom-in 0.5s ease;
}

.pulse-effect {
  animation: pulse 2s infinite;
}

.animate-line-advance {
  animation: lineGrow 1s ease forwards;
  background-image: linear-gradient(to right, rgba(16, 185, 129, 0.2), rgba(16, 185, 129, 1));
  height: 3px;
  border: none !important;
}

@keyframes zoom-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(217, 119, 6, 0.7);
  }

  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(217, 119, 6, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(217, 119, 6, 0);
  }
}

@keyframes lineGrow {
  0% {
    width: 0;
    opacity: 0;
  }

  100% {
    width: 64px;
    opacity: 1;
  }
}
</style>